import axios from "axios";
import axiosRetry from "axios-retry";

const devUrls = [
  "furbish.azurewebsites.net",
  "onsighttest.furbishco.com",
  "localhost:8080",
  "localhost:81",
];

const isDevEnv = devUrls.includes(window.location.host);

let baseURL = `https://onsight.furbishco.com/api`; // Varsayılan canlı

if (window.location.host.includes("localhost")) {
  // Eğer tarayıcıda localhost üzerindeysen kendi bilgisayarındaki API'ye git
  baseURL = `http://localhost:8080/api`;
} else if (isDevEnv) {
  baseURL = `https://onsighttest.furbishco.com/api`;
}

const axiosInstance = axios.create({
  baseURL,
});
axiosRetry(axiosInstance, { retries: 3 });

export default axiosInstance;